import { motion } from "framer-motion";
import { ArrowUpRight, Scissors, Wind, Hand, Sparkles } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, MESSAGES, IMAGES } from "@/constants/site";

const EASE = [0.22, 1, 0.36, 1];

const PRODUCTS = [
  {
    id: "extensao",
    testId: "product-card-extensao",
    btnTestId: "product-whatsapp-btn-extensao",
    title: "Extensão Capilar & Mega Hair",
    description: "Mais comprimento, volume e beleza.",
    badge: "Mais Desejado",
    image: IMAGES.extensao,
    message: MESSAGES.extensao,
  },
  {
    id: "cabelo-humano",
    testId: "product-card-cabelo-humano",
    btnTestId: "product-whatsapp-btn-cabelo-humano",
    title: "Cabelo Humano",
    description: "Conheça nossas opções disponíveis.",
    badge: "Qualidade VIP",
    image: IMAGES.cabeloHumano,
    message: MESSAGES.cabeloHumano,
  },
  {
    id: "perucas",
    testId: "product-card-perucas",
    btnTestId: "product-whatsapp-btn-perucas",
    title: "Perucas",
    description: "Beleza, estilo e naturalidade.",
    badge: "Lace Imperceptível",
    image: IMAGES.perucas,
    message: MESSAGES.perucas,
  },
  {
    id: "topos",
    testId: "product-card-topos",
    btnTestId: "product-whatsapp-btn-topos",
    title: "Topos Capilares",
    description: "Soluções para cobertura e volume capilar.",
    badge: "Efeito Natural",
    image: IMAGES.topos,
    message: MESSAGES.topos,
  },
];

const SALON_SERVICES = [
  { icon: Scissors, label: "Cortes" },
  { icon: Wind, label: "Escova" },
  { icon: Hand, label: "Manicure" },
  { icon: Sparkles, label: "Unhas em Gel" },
];

export const Products = () => (
  <section id="produtos" className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <div className="pointer-events-none absolute right-0 top-0 h-72 w-72 rounded-full bg-[#D4AF37]/5 blur-[120px]" />
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE }}
      className="mb-16 max-w-2xl"
    >
      <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-[#F9F8F6]">
        Nossas Soluções Exclusivas
      </p>
      <h2 className="font-display text-3xl font-semibold tracking-tight text-[#F9F8F6] sm:text-4xl lg:text-5xl">
        Produtos &amp; <span className="italic text-gold-gradient">Serviços</span>
      </h2>
      <p className="mt-5 text-base leading-relaxed text-[#A1A09E] sm:text-lg">
        Transformação sob medida com a mais alta qualidade em fios humanos.
      </p>
    </motion.div>

    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
      {PRODUCTS.map((product, i) => (
        <motion.article
          key={product.id}
          data-testid={product.testId}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
          className="group flex flex-col overflow-hidden rounded-2xl border border-white/5 bg-[#141416] transition-colors duration-500 hover:border-[#D4AF37]/40"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={product.image}
              alt={product.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#141416] via-transparent to-transparent" />
            <span className="absolute left-4 top-4 rounded-full border border-[#D4AF37]/40 bg-[#0A0A0B]/70 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.25em] text-[#F9F8F6] backdrop-blur-md">
              {product.badge}
            </span>
            <ArrowUpRight className="absolute right-4 top-4 h-5 w-5 text-[#F9F8F6] opacity-0 transition-all duration-500 group-hover:translate-x-1 group-hover:opacity-100" />
          </div>
          <div className="flex flex-1 flex-col p-6">
            <h3 className="font-display text-xl font-medium text-[#F9F8F6] sm:text-2xl">
              {product.title}
            </h3>
            <p className="mb-6 mt-2 text-sm leading-relaxed text-[#A1A09E]">
              {product.description}
            </p>
            <a
              href={waLink(product.message)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={product.btnTestId}
              className="mt-auto inline-flex items-center justify-center gap-2 rounded-full border border-[#D4AF37]/40 px-5 py-3 text-[10px] font-bold uppercase tracking-[0.2em] text-[#F9F8F6] transition-all duration-300 hover:border-[#D4AF37] hover:bg-[#0A0A0B] hover:text-[#F9F8F6]"
            >
              <WhatsAppIcon className="h-4 w-4" />
              Consultar pelo WhatsApp
            </a>
          </div>
        </motion.article>
      ))}
    </div>

    <motion.div
      data-testid="salon-services-band"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: EASE }}
      className="mt-16 rounded-3xl border border-[#D4AF37]/20 bg-gradient-to-br from-[#1C1B1F] to-[#141416] p-8 sm:p-10"
    >
      <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div>
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-[#F9F8F6]">
            E também no salão
          </p>
          <h3 className="font-display text-2xl font-semibold text-[#F9F8F6] sm:text-3xl">
            Serviços completos de beleza
          </h3>
        </div>
        <a
          href={waLink(MESSAGES.servicosSalao)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="salon-services-whatsapp-btn"
          className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-6 py-3.5 text-[10px] font-bold uppercase tracking-[0.2em] text-[#F9F8F6] transition-all duration-300 hover:border-[#D4AF37] hover:bg-[#0A0A0B] hover:text-[#F9F8F6]"
        >
          <WhatsAppIcon className="h-4 w-4" />
          Agendar pelo WhatsApp
        </a>
      </div>
      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
        {SALON_SERVICES.map((service) => (
          <div
            key={service.label}
            className="flex items-center gap-3 rounded-2xl border border-white/5 bg-[#0A0A0B]/50 px-5 py-4 transition-colors duration-300 hover:border-[#D4AF37]/30"
          >
            <service.icon className="h-5 w-5 shrink-0 text-[#F9F8F6]" />
            <span className="text-sm font-semibold text-[#F9F8F6]">{service.label}</span>
          </div>
        ))}
      </div>
    </motion.div>
  </section>
);
